export const TEN_DIGIT_NUMBER = '^[0-9]{10}$';
export const EMAIL_ADDRESS =
	'^[a-zA-Z0-9]+[a-z0-9._%+-]+@[a-z0-9.-]+[.]+[a-z]{2,}$';
